import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';
import { CreateDinoDuoDialog } from '@/components/CreateDinoDuoDialog';
import { useDinoDuos } from '@/hooks/useDinoDuos';

interface StartDinoDuoButtonProps {
  bookId?: string;
  friendId?: string;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}

export function StartDinoDuoButton({ 
  bookId, 
  friendId, 
  variant = 'outline',
  size = 'sm',
  className 
}: StartDinoDuoButtonProps) {
  const [open, setOpen] = useState(false);
  const { createDinoDuo } = useDinoDuos();

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setOpen(true)}
        className={className}
      >
        <Users className="h-4 w-4 mr-2" />
        Start a Duo 🦕
      </Button>
      
      <CreateDinoDuoDialog
        open={open}
        onOpenChange={setOpen}
        onCreateDuo={createDinoDuo}
      />
    </>
  );
}
